import { ReactNode } from 'react';

import { Dropdown } from 'components/Dropdown/Dropdown';
import { DropdownFoldMenu } from 'components/Dropdown/menus/Fold/DropdownFoldMenu';

import { FindAJobDropdownSearchItemData } from './data/FindAJobDropdownData';
import { findAJobDropdownDataByLocale } from './data/findAJobDropdownDataByLocale';

type Props = {
  locale: UserLocale;
  renderTrigger: (data: {
    triggerText: string;
    triggerHref: string;
  }) => ReactNode;
};

const dataBySearchItemType: Record<
  FindAJobDropdownSearchItemData['type'],
  { qaId: string; trackClickedName: string }
> = {
  job: {
    qaId: 'nav-job-link',
    trackClickedName: 'Find a Job Header Dropdown > Jobs',
  },
  internship: {
    qaId: 'nav-internship-link',
    trackClickedName: 'Find a Job Header Dropdown > Internships',
  },
  org: {
    qaId: 'nav-org-link',
    trackClickedName: 'Find a Job Header Dropdown > Orgs',
  },
};

export function FindAJobDropdown({ locale, renderTrigger }: Props) {
  const { triggerText, triggerHref, search, resources } =
    findAJobDropdownDataByLocale[locale];

  return (
    <Dropdown
      trigger={renderTrigger({ triggerText, triggerHref })}
      desktopTriggersOnHover
    >
      <DropdownFoldMenu
        left={{
          title: search.title,
          items: search.items.map((searchItem) => ({
            icon: searchItem.icon,
            title: searchItem.title,
            href: searchItem.href,
            qaId: dataBySearchItemType[searchItem.type].qaId,
            trackClickedName:
              dataBySearchItemType[searchItem.type].trackClickedName,
          })),
        }}
        right={{
          title: resources.title,
          items: resources.items.map((resourceItem) => ({
            image: resourceItem.image,
            title: resourceItem.title,
            description: resourceItem.description,
            href: resourceItem.href,
          })),
        }}
      />
    </Dropdown>
  );
}
